// extracted by mini-css-extract-plugin
export default {"choose":"styles_choose__yhhNP"};